import { FormPagePropertyItemMultipleSelection } from 'backend';
import { MULTIPLE_SELECTION_PROPERTY_INPUT_TYPE } from 'shared';
import { PropertyItemElement } from '..';
import { getSelectionPropertyItemSubtextFormCustomizeQuerySelector } from './singleSelection';

export const getMultipleSelectionPropertyItemElementFormCustomize = (
  propertyItem: FormPagePropertyItemMultipleSelection,
): PropertyItemElement => {
  switch (propertyItem.inputFormat.inputType) {
    case MULTIPLE_SELECTION_PROPERTY_INPUT_TYPE.checkbox:
    case MULTIPLE_SELECTION_PROPERTY_INPUT_TYPE.checkboxHorizontal: {
      const checkboxes = document.querySelectorAll<HTMLElement>(
        `input[type="checkbox"][data-nform-property-id="${propertyItem.propertyId}"]`,
      );
      const subtexts = propertyItem.candidates
        .filter(
          (candidate) => candidate.subtext != null && candidate.value != null,
        )
        .map((candidate) =>
          document.querySelector<HTMLElement>(
            getSelectionPropertyItemSubtextFormCustomizeQuerySelector(
              propertyItem.propertyId,
              candidate.value ?? 0,
            ),
          ),
        )
        .filter(
          (element): element is Exclude<HTMLElement, null> => element != null,
        );
      if (checkboxes.length == 0) {
        return {};
      }
      return {
        checkboxes: Array.from(checkboxes),
        subtexts: subtexts,
      };
    }
  }
};
